import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ActivityDetail from "../pages/activity-detail/page";
import Auth from "../pages/auth/page";
import MyActivities from "../pages/my-activities/page";
import Profile from "../pages/profile/page";
import AdminPage from "../pages/admin/page";
import MembersPage from "../pages/members/page";
import NotreMission from "../pages/notre-mission/page";
import ReglesCommunaute from "../pages/regles-communaute/page";
import Contact from "../pages/contact/page";
import Messages from "../pages/messages/page";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import ConfirmEmail from "@/pages/auth/ConfirmEmail";


const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/activite/:id",
    element: <ActivityDetail />,
  },

  {
    path: "/messages",
    element: <Messages />
  },
  {
    path: "/messages/:conversationId",
    element: <Messages />
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/confirmer-email",
    element: <ConfirmEmail />
  },
  {
    path: "/mot-de-passe-oublie",
    element: < ForgotPassword />
  },
  {
    path: "/reinitialiser-mot-de-passe",
    element: <ResetPassword />
  },
  {
    path: "/mes-activites",
    element: <MyActivities />,
  },
  {
    path: "/mon-profil",
    element: <Profile />,
  },
  // {
  // Desactivé temporairement
  //   path: "/le-coin",
  //   element: <LeCoin />,
  // },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/membres",
    element: <MembersPage />,
  },
  {
    path: "/notre-mission",
    element: <NotreMission />,
  },
  {
    path: "/regles-communaute",
    element: <ReglesCommunaute />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;